import setCookie from 'set-cookie-parser';
import { playSetCookies } from './genericService';
function convertToMap(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const map = new Map(Object.entries(obj));
        return map;
    }
    return new Map();
}
/**
 * mapHeaders keeps a map of set of values restricted to 'set-cookie' only
 * and nothing else as decided originally (CSP etc ...)
 * @param {*} mapHeaders
 * @param {*} headers
 */
export function mergeHeaders(mapHeaders, headers) {
    const key = 'set-cookie';
    if (headers) {
        // const map = new Map(headers.entries() || []);
        const map = convertToMap(headers) || new Map();
        if (map.has(key)) {
            if (!mapHeaders.has(key)) {
                mapHeaders.set(key, new Set());
            }
            mapHeaders.get(key).add(map.get(key));
        }
    }
}
export function parseCookies(attribute) {
    const cookieStrings = setCookie.splitCookiesString(attribute);
    return setCookie.parse(cookieStrings);
}
export function mergeCookies(mapCookie, cookies) {
    const restrictionSet = new Set(playSetCookies());
    if (Array.isArray(cookies)) {
        cookies
            .filter((cookie) => restrictionSet.has(cookie.name))
            .forEach((cookie) => {
            mapCookie.set(cookie.name, cookie);
        });
    }
}
